export const SHOP_LIST = 'cdb/shop/listnear'
export const QR_CODE = 'cdb/cabinet/checkisok'
export const ZH_CODE = 'cdb/cabinet/zhorder'

export const ORDER_TEMP1 = 'cdb/cabinet/createorder'
export const ORDER_TEMP = 'cdb/cabinet/useBalanceToRent'
export const ORDER_CZ = 'cdb/cabinet/order'
export const ORDER_CHECK = 'cdb/cabinet/ordercheck'

// 检查mifi宝是否可租借
export const MIFI_CHECK = 'chargenow/mifi/checkisok'
export const MIFI_DEVICEDEPOSIT = 'chargenow/mifi/cabinetDisposit'
export const MIFI_PICKUP = 'chargenow/mifi/pickCabinet'
export const MIFI_FLOWUSE = 'chargenow/mifi/flowUsageList'
export const MIFI_CREATEORDER = 'cdb/payment/bajiemifi/createOrderByScan' // mifi弹宝
export const MIFI_BINDSN = 'chargenow/mifi/bindSN' // 设备续费SN直接绑定已经买的仅套餐

// 查询流量使用详情
export const MIFI_PACKAGEUSE = 'chargenow/mifi/flowUsageList'

export const MIFI_QR_CODE = 'cdb/mifi/urlGetSn'

export const MIFI_BIND = '/app/mifi/card/device/bind'

export const MIFI_DEVICE = '/app/mifi/card/device/list'

export const MIFI_DEFAULT = '/app/mifi/card/device/setDefault'

export const MIFI_DELETE = '/app/mifi/card/device/deleteDevice'

export const MIFI_PAY_LIST = 'cdb/mifi/agentPaymentList'

export const MIFI_PACKAGE_USE = 'cdb/mifi/packageUsage'

export const MIFI_ORDER_DETAIL = 'cdb/mifi/orderDetail'

export const MIFI_CANCEL_ORDER = 'cdb/mifi/cancelOrder'

export const MIFI_DEVICE_SECRET = 'cdb/mifi/'

export const MIFI_DICT_CODE = '/app/mifi/card/base/appPkgTabList'

export const MIFI_PRODUCT_LIST = '/app/mifi/card/product/productListByPkgTab'

export const MIFI_PRODUCT_PAY = '/app/mifi/card/pay/buy'

export const MIFI_PRODUCT_REPAY = '/app/mifi/card/pay/repay'

export const MIFI_PRODUCT_RCHARGE = '/app/mifi/card/recharge/product/list'

export const MIFI_PRODUCT_RCHARGE_BUY = '/app/mifi/card/recharge/product/buy'

export const MIFI_PRODUCT_ORDERS = '/app/mifi/card/order/productOrders'

export const MIFI_PRODUCT_CANCEL_ORDERS = '/app/mifi/card/order/cancelOrders'

export const MIFI_DEVICE_SUITE_TOTAL_PKG = '/app/mifi/card/devPkg/deviceSuiteTotalPkg'

export const MIFI_DEVICE_INFO = '/app/mifi/card/device/deviceInfo'

export const MIFI_DEVICE_PKG = '/app/mifi/card/device/queryPkg'

export const MIFI_DEVICE_OPERATION_CMD = '/app/mifi/card/device/operationCmd'
